import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult } from '../../rules';
import IsProjectTypeSolar from '../../rules/IsProjectTypeSolar';
import PrimaryMotivationForSolarIsOther from '../../rules/PrimaryMotivationForSolarIsOther';

class PrimaryMotivationForSolarOtherRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const primaryMotivationForSolarIsOther =
      PrimaryMotivationForSolarIsOther.evaluate(data);

    const isSolar = IsProjectTypeSolar.evaluate(data);

    return primaryMotivationForSolarIsOther && isSolar
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PrimaryMotivationForSolarOtherRuleset();
